<template>
  <div class="sp-template">
    <div class="h-title">转单</div>
    <el-card class="box-card">
      <transfer-content></transfer-content>
    </el-card>
  </div>
</template>

<script>
import TransferContent from './TransferContent'
export default {
  components: {
    TransferContent
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/orderOperation/transfernumber.vue